import { decode } from 'jsonwebtoken'
import { encryptAES } from '../../core-apis/src/apis/config/utils'
import { parsedRolesArrayToRolesObject } from './parsedRoles'
import type { ICookieAccessToken } from '../../interfaces/src/auth.interface'

const AUTH_KEY_SECRET = process.env.AUTH_KEY_SECRET || ''

interface IDefaultCookieAccessToken {
  'https://wiggot.com/user': {
    email: string
    emailVerified: boolean
    id: string
    name: string
    nickname: string
    roles: string[]
    token: string
    userId: string
    binaryRoles: number
    metadata?: {
      development?: string
    }
  }
  'https://wiggot.com/roles': string[]
  iss: string
  sub: string
  aud: string[]
  iat: number
  exp: number
  scope: string
  gty: string
  azp: string
}

export const decodeJWTCookieAccessToken = (
  cookie: string
): ICookieAccessToken => {
  const decodedAccessToken = decode(cookie) as IDefaultCookieAccessToken
  const user = decodedAccessToken?.['https://wiggot.com/user']
  const auth0Roles = decodedAccessToken?.['https://wiggot.com/roles']
  return {
    user: {
      ...user,
      roles: parsedRolesArrayToRolesObject(user?.roles)
    },
    auth0Roles
  }
}

export const encryptPassword = (password: string) => {
  return encryptAES(password, AUTH_KEY_SECRET)
}
